import React from "react";

const RowImages = ({ src }) => {
 

  return (
        <img src={src} className="row-image" alt="no profile" />
  )
};



export default RowImages;
